(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koc-comic-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koc-comic-carousel')) {
    customElements.define('koc-comic-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.viewport = this.querySelector('.koc-carousel__viewport');
        if (!this.viewport) return;

        this.group = this.querySelector('.koc-carousel__group');
        this.track = this.querySelector('.koc-carousel__track');
        this.controls = this.querySelector('.koc-carousel__controls');
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.speed = Number(this.dataset.speed) || 30;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.controller = new AbortController();

        const options = { signal: this.controller.signal };

        const pause = () => {
          this.paused = true;
          this.updateButton();
        };

        this.viewport.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') this.hovered = true;
        }, options);

        this.viewport.addEventListener('pointerleave', () => {
          this.hovered = false;
        }, options);

        this.viewport.addEventListener('focusin', () => {
          this.focused = true;
        }, options);

        this.viewport.addEventListener('focusout', event => {
          this.focused = this.viewport.contains(event.relatedTarget);
        }, options);

        this.viewport.addEventListener('pointerdown', pause, options);

        this.viewport.addEventListener('wheel', pause, {
          ...options,
          passive: true
        });

        this.viewport.addEventListener('keydown', pause, options);

        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          this.position = this.viewport.scrollLeft;
          this.updateButton();
        }, options);

        this.querySelector('[data-previous]').addEventListener(
          'click',
          () => this.step(-1),
          options
        );

        this.querySelector('[data-next]').addEventListener(
          'click',
          () => this.step(1),
          options
        );

        this.motion.addEventListener('change', () => {
          if (this.motion.matches) pause();
        }, options);

        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.viewport);
        this.resize.observe(this.group);

        this.intersection = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
        });

        this.intersection.observe(this);

        this.measure();
        this.last = null;

        const frame = time => {
          const elapsed = this.last === null
            ? 0
            : Math.min(time - this.last, 50);

          this.last = time;

          if (
            this.loopWidth &&
            !this.paused &&
            !this.hovered &&
            !this.focused &&
            this.visible &&
            !document.hidden
          ) {
            this.position = (
              this.position + this.speed * elapsed / 1000
            ) % this.loopWidth;

            this.viewport.scrollLeft = this.position;
          } else {
            this.position = this.viewport.scrollLeft;
          }

          this.frameId = requestAnimationFrame(frame);
        };

        this.frameId = requestAnimationFrame(frame);
      }

      measure() {
        const width = this.group.getBoundingClientRect().width;

        this.loopWidth = width > this.viewport.clientWidth + 1
          ? width
          : 0;

        if (this.loopWidth && !this.copy) {
          this.copy = this.group.cloneNode(true);
          this.copy.setAttribute('aria-hidden', 'true');

          this.copy.querySelectorAll('a').forEach(link => {
            link.setAttribute('tabindex', '-1');
          });

          this.track.appendChild(this.copy);
        } else if (!this.loopWidth && this.copy) {
          this.copy.remove();
          this.copy = null;
        }

        this.controls.hidden = !this.loopWidth;

        this.position = this.loopWidth
          ? this.viewport.scrollLeft % this.loopWidth
          : 0;

        this.viewport.scrollLeft = this.position;
        this.updateButton();
      }

      updateButton() {
        this.toggle.textContent = this.paused
          ? 'Play scrolling'
          : 'Pause scrolling';
      }

      step(direction) {
        if (!this.loopWidth) return;

        this.paused = true;
        this.updateButton();

        const distance = Math.max(
          100,
          this.viewport.clientWidth * 0.7
        );

        this.position = (
          (
            this.viewport.scrollLeft + direction * distance
          ) % this.loopWidth + this.loopWidth
        ) % this.loopWidth;

        this.viewport.scrollLeft = this.position;
      }

      disconnectedCallback() {
        if (!this.controller) return;

        this.controller.abort();
        this.controller = null;

        cancelAnimationFrame(this.frameId);
        this.resize.disconnect();
        this.intersection.disconnect();

        if (this.copy) this.copy.remove();
        this.copy = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
